function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWatchRace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5471,-809)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.819433,1.2326e-32,3.08149e-32,0.819433,-240.143,750.908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.302618,0,0,1.06683,1193.99,-7.68759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1845.16,84.451C1845.16,78.827 1829.07,74.26 1809.24,74.26L1616.6,74.26C1596.77,74.26 1580.67,78.827 1580.67,84.451L1580.67,104.833C1580.67,110.457 1596.77,115.024 1616.6,115.024L1809.24,115.024C1829.07,115.024 1845.16,110.457 1845.16,104.833L1845.16,84.451Z",
    style: {
      fill: "rgb(26,122,230)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.20641e-17,0.686959,-0.629106,3.85216e-17,5710,-2571.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3878.51,6336.25L3891.83,6367L3865.19,6367L3878.51,6336.25Z",
    style: {
      fill: "white"
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWatchRace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/watch_race.1af0293385f91479396c260d1e9c58f0.svg";